import React from "react";
import LocationBanner from "components/locationBanner/index";
import AcadmicInstruction from "components/reusableComponents/AcadmicInstruction";
import LocalizationMidText from "components/reusableComponents/localizationMidText";
import WhatLocalization from "components/reusableComponents/whatLocalization";
import CommonUse from "components/LocationReusableComp/commonuse";
import WhatsAppComp from "components/reusableComponents/whatsappComp";
import SpeceficTranslation from "components/LocationReusableComp/speceficTranslation";
import GeneralLocalization from "components/reusableComponents/generalLocalization";
import UseCase from "components/reusableComponents/useCases";
import WhatChooseUs from "components/homepage/whyChooseUs";
import Reviews from "components/homepage/reviews";
import TranslationServices from "components/homepage/translationServices";
import { Data, MoreData } from "../websiteTranslation/config";
import TranslateAgency from "components/homepage/translateAgency";

export default function index() {
  return (
    <div>
      <LocationBanner
        title="Localization Services"
        backgroundCol="bg-midBlue"
        content="If you’re taking the time to translate your website into another language, then you presumably want to reach out to people in another country. That’s where localization comes in. At Tomedes, we localize your website, apps, games, and content to be able to reach the people that matter most: your intended audience. We do this through localization services in over 120 languages and 950+ language pairs."
        formOrangeHead="Get in touch "
        formWhiteHead=" with our
        localization agency"
      />

      {/* <AcadmicInstruction
        head="Localization Services "
        content="The world's leading brands, Fortune 500 companies, and small businesses alike trust Tomedes with their global localization goals. Isn't it time you do as well?"
        colorHead="Trusted"
        secondHead=""
        thirdColorHead="text-LightBlue"
        thirdHead="by the World's Leading Brands"
      /> */}
      <TranslateAgency
        head="Localization Services"
        colorHead="Trusted"
        lastHeadText="by the World's Leading Brands"
        content="The world's leading brands, Fortune 500 companies, and small businesses alike trust Tomedes with their global localization goals. Isn't it time you do as well?"
      />
      <LocalizationMidText />
      <WhatLocalization />
      <CommonUse
        backgroundCol="bg-midBlue"
        title="Full-Suite Localization Services"
        data={Data}
      />
      <WhatsAppComp />
      <SpeceficTranslation
        FirstOrange="Localize"
        linkName="SEE OUR SUPPORTED LANGUAGES"
        SecondWhite="In Over 120 Languages and 950+ Language Pairs."
        headColor="text-lightBlue"
        Content="Many Fortune 500 companies have made serious translation blunders, and even caused cultural offense by ignoring the need for localization services. It is very risky - and possibly even irresponsible, in regards to certain medical and life sciences translations - to simply ignore proper methods of professional localization. This is especially true for translations such as English to Hindi, English to Farsi, English to Chinese, or any other language pairing belonging to cultures with pronounced differences and perspectives."
        backgroundCol="bg-whatsapp-comp"
      />
      <GeneralLocalization />
      <UseCase />
      <CommonUse
        backgroundCol="bg-darkBlue"
        title="Compete in the Global Marketplace With Localization Services"
        para="With thousands of trained linguists in our network, we can hand-pick the technical translation team that are
        knowledgeable about the languages and disciplines required."
        data={MoreData}
      />
      <WhatChooseUs backgroundCol="bg-darkBlue" />
      <Reviews backgroundCol="bg-midBlue" />
      <TranslationServices backgroundCol="bg-darkBlue" />
    </div>
  );
}
